import { makeStyles } from '@material-ui/core/styles'

import { colors, hexToRgba } from '@galo-monitor/styles'

import 'flatpickr/dist/themes/material_green.css'

const useStyles = makeStyles(() => ({
  '@global': {
    '.flatpickr-month,.flatpickr-weekdays,.flatpickr-monthDropdown-month,.flatpickr-weekday,.flatpickr-monthDropdown-months,.selected': {
      backgroundColor: `${ colors.primary  }!important`
    },

    '.selected': {
      borderColor: `${ colors.primary  }!important`
    },

    '.flatpickr-weekday': {
      color: `${ colors.white  }!important`,
      textShadow: `0 0 2px ${ hexToRgba(colors.black, 0.2) }`
    },

    'span.flatpickr-weekday': {
      whiteSpace: 'normal'
    },

    '.hide-flatpickr-native-input': {
      display: 'none'
    },

    '.flatpickr-month, .flatpickr-prev-month, .flatpickr-next-month': {
      fill: `${ colors.white  }!important`,
      color: `${ colors.white  }!important`,
      textShadow: `0 0 2px ${ hexToRgba(colors.black, 0.2) }`
    },

    '.flatpickr-calendar.arrowTop:after': {
      borderBottomColor: `${ colors.secondary  }!important`
    },

    '.flatpickr-calendar.arrowBottom:after': {
      borderTopColor: `${ colors.white  }!important`
    }
  }
}))

export default useStyles
